import React, {VoidFunctionComponent} from 'react';

import SVGIcon, {SVGIconProps} from '../svg-icon/svg-icon';

export enum LocationIconVariant {
  BLUE = 'blue',
  YELLOW = 'yellow',
  DEFAULT = 'default'
}

interface Props extends SVGIconProps {
  variant?: LocationIconVariant;
}

const LocationIcon: VoidFunctionComponent<Props> = props => {
  const {variant = LocationIconVariant.DEFAULT, ...svgProps} = props;

  const baseColor =
    (variant === LocationIconVariant.BLUE && 'var(--dhm-map-blue)') ||
    (variant === LocationIconVariant.YELLOW && 'var(--dhm-map-dark-yellow)') ||
    'var(--dhm-map-gray)';
  const dotColor =
    (variant === LocationIconVariant.BLUE && 'var(--dhm-map-light-blue)') ||
    (variant === LocationIconVariant.YELLOW && 'var(--dhm-map-yellow)') ||
    'var(--dhm-map-white)';

  return (
    <SVGIcon {...svgProps}>
      <path
        fill={baseColor}
        d="M 19.2,10.2 C 19.2,15.3765 12,21 12,21 12,21 4.8,15.3765 4.8,10.2 4.8,6.22355 8.02355,3 12,3 c 3.9765,0 7.2,3.22355 7.2,7.2 z"
      />
      <circle fill={dotColor} r="3" cy="10.200069" cx="12.00007" />
    </SVGIcon>
  );
};

export default LocationIcon;
